import { MenuItem, Select } from "@mui/material";

import { BUCKET_SUMMARY_LABELS, BucketSummaryEnum } from "constants/index";
import { BucketTotals } from "helpers/types";

interface BucketSummarySelectProps {
  value: BucketSummaryEnum;
  bucketTotals: BucketTotals | undefined;
  onChange: (value: BucketSummaryEnum) => void;
}

const BucketSummarySelect = ({
  value,
  bucketTotals,
  onChange,
}: BucketSummarySelectProps) => (
  <Select
    size="small"
    value={value}
    onChange={(event) => onChange(event.target.value as BucketSummaryEnum)}
  >
    {Object.values(BucketSummaryEnum).map((summary) => (
      <MenuItem
        key={summary}
        value={summary}
        disabled={!bucketTotals?.[summary]}
      >
        {BUCKET_SUMMARY_LABELS[summary]}
      </MenuItem>
    ))}
  </Select>
);

export default BucketSummarySelect;
